import { render } from "./HelloWorld.vue?vue&type=template&id=43ebd51e&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=43ebd51e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\reino\\Desktop\\testt\\de-tol\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ebd51e"]])

export default __exports__